import _ from 'lodash';

const getFormValues = (formObj) => {
    let values = {};
    _.forEach(formObj, (data, key) => {
        if (!_.isNil(data.value)) {
            values[key] = data.value;
        }
    });
    return values;
};

export default getFormValues;